import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  Image,
  Linking,
  Platform,
  ScrollView,
  Dimensions,
  TouchableOpacity
} from "react-native";

import GlobalStyles from "../components/GlobalStyles";
import MenuBar from "../components/headers/MenuBar";
import FooterBarWide from "../components/footerBarWide";
import StatusBar from "../components/headers/StatusBar";
import BackButton from "../components/BackButton";
import CustomIcon from "../components/CustomIcon";
import GenericButton from "../components/GenericButton.js"

export default function AboutUsScreen() {
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerMB}>
      {win.width > 768 ? (
        <View style={GlobalStyles.fullHeaderBarY}>
          <MenuBar data="6" />
          <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
            <View
              style={[
                GlobalStyles.headerContainerKLYellow,
                { alignSelf: "center" },
              ]}
            >
              <View style={GlobalStyles.headerTextYellowForweb}>
                <View style={GlobalStyles.backIconContainerForWeb}>
                  <BackButton />
                </View>
                <View>
                  <Text style={GlobalStyles.headingStyle}>About us</Text>
                  <Text style={GlobalStyles.subheaderStyleWeb}>{"\n"}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : (
        <View style={styles.headerContainer}>
          <StatusBar data="BM" />
          <View style={styles.headerText}>
            <Text style={GlobalStyles.headingStyle}>About us</Text>
          </View>
        </View>
      )}
      <ScrollView style={styles.scrollView}>
        <View style={GlobalStyles.containerNmax}>
          <View style={styles.bodyContainerFull}>
            <View style={styles.boxContainer}>
              <View style={styles.logoContainer}>
                <Image
                  style={styles.smallLogo}
                  source={require("../assets/res/Aura_Alpha_PlayOnce.gif")}
                  resizeMode="contain"
                />
              </View>
              <Text
                style={[
                  GlobalStyles.bodyTextStyleInvetment,
                  { lineHeight: 22, fontSize: 16, marginBottom: 5 },
                ]}
              >
                A better way to reward loyalty and a better way to be rewarded
              </Text>
              <View style={styles.formStyle}>
                <View style={styles.middleTextContainer}>
                  <View style={styles.formMiddleTextContainer}>
                    <Text style={GlobalStyles.bodyTextStyleInvetment}>
                      Aura is turning the traditional approach to loyalty
                      programs on its head. You earn cash back for your
                      purchases, not points, that you can spend how you want. Better still, Aura will donate cash to
                      support your chosen charity or local community group
                    </Text>
                  </View>
                  <View style={styles.formradioButtonTextContainer}>
                    <Text style={GlobalStyles.bodyTextStyleInvetment}>
                      It’s the program where your loyalty is earned, and the
                      community rewarded.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={[
                  GlobalStyles.buttonContainerInvest,
                  { marginTop: 10, marginBottom: 5 },
                ]}
              >
                <View
                  style={[
                    GlobalStyles.submitContinueButtonStyleInvestment,
                    { width: "100%" },
                  ]}
                >
                  {Platform.OS === "web" ? (
                     // this comment can be removed after two months(3/8/23)
                    // <Text
                    //   style={[
                    //     GlobalStyles.textButtonStyleInvestment,
                    //     { color: "#333333" },
                    //   ]}
                    //   onPress={() =>
                    //     window.open("https://aura.club/", "_blank")
                    //   }
                    // >
                    //   VISIT AURA.CLUB
                    // </Text>
                    <GenericButton
                      buttonText='VISIT AURA.CLUB'
                      onPress={() => window.open("https://aura.club/", "_blank")}
                    />
                  ) : (
                    // this comment can be removed after two months(3/8/23)
                    // <Text
                    //   style={[
                    //     GlobalStyles.textButtonStyleInvestment,
                    //     { color: "#333333" },
                    //   ]}
                    //   onPress={() => Linking.openURL("https://aura.club/")}
                    // >
                    //   VISIT AURA.CLUB
                    // </Text>
                    <GenericButton
                      buttonText='VISIT AURA.CLUB'
                      onPress={() => Linking.openURL("https://aura.club/")}
                    />
                  )}
                </View>
              </View>
            </View>
            <View style={styles.buttonContainer}>
              {Platform.OS === "web" ? (
                <OptionButton
                  icon="icon-reports"
                  label="T&Cs"
                  subtext="More information"
                  onPress={() =>
                    window.open("https://aura.club/terms-and-conditions/", "_blank")
                  }
                />
              ) : (
                <OptionButton
                  icon="icon-reports"
                  label="T&Cs"
                  subtext="More information"
                  onPress={() =>
                    Linking.openURL("https://aura.club/terms-and-conditions/")
                  }
                />
              )}

              {Platform.OS === "web" ? (
                <OptionButton
                  icon="icon-privacy"
                  label="Privacy"
                  subtext="Details"
                  onPress={() =>
                    window.open("https://aura.club/privacy-policy/", "_blank")
                  }
                />
              ) : (
                <OptionButton
                  icon="icon-privacy"
                  label="Privacy"
                  subtext="Details"
                  onPress={() =>
                    Linking.openURL("https://aura.club/privacy-policy/")
                  }
                />
              )}
            </View>
            <View style={styles.footerContainerStyle}>
              <Text style={styles.footerText}>
              </Text>
            </View>
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

function OptionButton({ icon, label, onPress, subtext, isLastOption }) {
  return (
    <TouchableOpacity
      style={styles.containerBox}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View style={styles.SubmitButtonStyle}>
        <View style={styles.optionIconContainer}>
          {label != 'Statements' ? <CustomIcon name={icon} size={24} color="rgba(0,0,0,0.99)" /> : <Ionicons name="document-outline" size={18} color="black" />}
        </View>
        <View style={styles.optionTextContainer}>
          <Text style={styles.optionText}>{label}</Text>
        </View>
        <View style={styles.optionSubtextContainer}>
          <Text style={styles.optionSubtext}>{subtext}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  headerContainer: {
    height: 180,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 50,
  },
  headerText: {
    paddingLeft: 50,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "left",
    marginBottom: 20,
    color: "#ffffff",
  },
  bodyContainer: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 30,
    maxWidth: 800,
    alignSelf: "center",
  },
  logoContainer: {
    alignItems: "center",
    marginBottom: 20,
  },
  smallLogo: {
    width: 107,
    height: 57,
    resizeMode: "contain",
  },
  boxContainer: {
    backgroundColor: "#ffffff",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 25,
    paddingRight: 25,
  },
  bodyContainerFull: {
    paddingTop: 40,
    paddingLeft: 25,
    paddingRight: 25,
  },
  footerContainerStyle: {
    marginTop: 25,
    paddingBottom: 40,
  },
  footerText: {
    color: "#ffff",
    fontFamily: "montserrat-italic",
    textAlign: "center",
    fontSize: 10,
    lineHeight: 16,
  },
  buttonContainer: {
    marginTop: 30
  },
  containerBox: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    marginBottom: 15,
  },
  SubmitButtonStyle: {
    flexDirection: "row",
  },
  optionTextContainer: {
    flex: 6,
    alignSelf: "center",
  },
  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "left",
  },
  optionSubtextContainer: {
    flex: 6,
    alignSelf: "center",
  },
  optionSubtext: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "right",
  },
  optionIconContainer: {
    flex: 2,
    alignSelf: "center",
  },
});
